/* This example requires Tailwind CSS v2.0+ */
import {
    RefreshIcon,
    ShoppingBagIcon,
    ShoppingCartIcon,
} from '@heroicons/react/outline'
import Link from 'next/link'
import { CartAPI } from '../../apis/CartAPI'
import { useLoading } from '../../context/LoadingProvider'

export default function BlankCart() {
    const { setLoading } = useLoading()

    const handleRefresh = async () => {
        setLoading(true)
        await CartAPI.getForceCheckout()
        window.location.reload()
    }

    return (
        <div className="text-center">
            <div className="flex justify-center">
                <ShoppingBagIcon className="h-12 w-12 text-gray-400" />
            </div>

            <h3 className="mt-2 text-sm font-medium text-olm-black">
                Cart is Empty
            </h3>
            <p className="mt-1 text-sm text-gray-500">
                Add Some Products to Cart.
            </p>
            <div className="mt-6 space-x-2">
                <Link href="/products">
                    <button
                        type="button"
                        className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-olm hover:bg-olh focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-olh">
                        <ShoppingCartIcon
                            className="-ml-1 mr-2 h-5 w-5"
                            aria-hidden="true"
                        />
                        <span className="hidden md:inline-block">Shop Now</span>
                        <span className="md:hidden">
                            {' '}
                            Please open in iPad or Desktop to Order
                        </span>
                    </button>
                </Link>
                <button
                    type="button"
                    onClick={handleRefresh}
                    className="inline-flex items-center px-4 py-2 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-olm hover:bg-olh focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-olh">
                    <RefreshIcon
                        className="-ml-1 mr-2 h-5 w-5"
                        aria-hidden="true"
                    />
                    <span className="hidden md:inline-block">Refresh</span>
                    <span className="md:hidden">
                        {' '}
                        Please open in iPad or Desktop to Order
                    </span>
                </button>
            </div>
        </div>
    )
}
